// try to name these the same to/like the Rails ones
//
// these enum values are stored in BookmarkLink so if you make a value end up representing a different page
// bookmarks will get messed up
export enum Route {
  root = 1,

  dashboard = 1000,
  actionsDashboard = 1001,
  pendingActionsActionsDashboard = 1002,
  pendingAssignmentsActionsDashboard = 1003,
  previouslyReviewedSubmissionsActionsDashboard = 1004,
  submissionsDashboard = 1005,
  editSubmissionFromDashboard = 1006,
  notifications = 1007,

  organizationMemberships = 2000,
  organizationGroups = 2001,
  organizationRoles = 2002,
  organizationSearchForms = 2010,
  organizationGroupSearchUsers = 2011,
  recentlyUsedDocuments = 2012,
  organizationSearchGroups = 2013,
  organizationQuickLinkFolders = 2014,
  organizationSearchPaymentGateways = 2015,
  organizationPaymentGateway = 2016,

  editForm = 3000,
  formSubmissionCreate = 3001,
  formSubmissionCreateOnFirstAutosave = 3002,
  resetPreviewForm = 3003,
  formSubmissionCreatePreview = 3004,
  formSearchObjectModelEntriesForLookupField = 3005,
  formSubmissionNew = 3006,

  editLicense = 3100,
  searchAwardedLicenses = 3101,

  editCertificate = 3200,
  fetchSourceDocument = 3201,
  fetchCertificate = 3202,
  certificatePreview = 3203,


  editObjectModel = 3300,
  editObjectModelRelationships = 3301,
  searchObjectModels = 3302,
  objectModels = 3303,
  objectModelProperties = 3304,
  objectModel = 3305,
  editObjectModelActions = 3306,
  objectModelEntries = 3307,
  objectModelFakeEntries = 3308,
  publishObjectModel = 3309,
  objectModelPublishingDependencies = 3310,
  objectModelPublishedObjectModel = 3311,
  objectModelEntriesNew = 3312,
  objectModelEntriesEdit = 3313,
  objectModelEntriesPerformAction = 3314,
  objectModelLinkedForms = 3315,
  objectModelShow = 3316,
  objectModelListViews = 3317,
  objectModelRelatedListViews = 3318,
  objectModelEntriesChangeHolder= 3319,
  objectModelEntriesResendClaimRecordNotification = 3320,
  objectModelEntriesCreateShell = 3321,
  objectModelEntriesInspect = 3322,
  objectModelSearchProcessFlows = 3323,
  objectModelEntriesResendAccountRelationClaimRecordNotification = 3324,
  fetchEntryRelationsAndEntries = 3325,
  checkForEntryRelation = 3326,
  objectModelSearchDetailViews = 3327,
  objectModelPerformAction = 3328,
  publishedAccountRelationSearchUsers = 3329,

  listViews = 3400,
  editListView = 3401,
  editListViewLayout = 3402,
  editListViewFilters = 3403,
  editListViewSettings = 3404,
  previewListView = 3405,
  entriesListView = 3406,
  listView = 3407,
  publishListView = 3408,
  listViewPublishingDependencies = 3409,
  listViewClone = 3410,
  fakeEntriesListView = 3411,
  entityDashboardListView = 3412,
  listViewBulkActions = 3413,
  listViewForLookup = 3414,

  detailViews = 3501,
  editDetailView = 3502,
  associatedListViewDetailView = 3503,
  detailView = 3504,
  previewDetailView = 3505,
  previewDetailViewListView = 3506,
  publishDetailView = 3507,
  detailViewPublishingDependencies = 3508,
  detailViewClone = 3509,
  detailViewContentElementLinkedForms = 3510,
  detailViewFileAttachments = 3511,
  modelHistoryView = 3512,
  detailViewContentElementLinkedFormSubmissions = 3513,
  detailViewFormSubmissionList = 3514,
  detailViewEditMode = 3515,
  userDashboardDetailView = 3516,
  detailViewEntryShow = 3517,

  mapping = 3601,
  editMapping = 3602,
  mappingPublishedMapping = 3603,
  mappingPublishingDependencies = 3604,
  publishMapping = 3605,
  mappingLinkedModelData = 3606,

  publicProfile = 3701,
  editPublicProfile = 3702,
  publishPublicProfile = 3703,
  unpublishPublicProfile = 3704,
  publicProfiles = 3705,
  getApplication = 3706,

  entityType = 3801,
  editEntityType = 3802,
  publishEntityType = 3803,
  unpublishEntityType = 3804,
  deleteEntityType = 3805,
  entityTypeObjectModels = 3806,

  objectModelRelations = 3900,

  editVisualization = 4001,
  previewVisualization = 4002,
  publishVisualization = 4003,
  visualizationShow = 4004,


  processFlows = 4000,
  editProcessFlow = 4101,
  processFlowSearchObjectModels = 4102,
  processFlowSearchForms = 4103,
  processSearchCertificates = 4104,
  fetchCertificateDynamicInputs= 4105,
  getObjectModelRelations = 4106,
  publishProcessFlow = 4107,
  processFlowPublishingDependencies = 4108,
  processFlowSearchProcessFlows = 4109,
  executeDebugProcessFlow = 4110,
  processFlowSearchDetailViews = 4111,
  processFlowSearchListViews = 4112,

  resumeProcessFlowSubmission = 4201,
  processFlowSubmissionPaused = 4202,
  processFlowSubmissionFileUploads = 4203,
  processFlowSubmissionFileUpload = 4204,

  portals = 5000,
  editPortal = 5001,

  organizationSettingsInfo = 6000,
  organizationSettingsBranding = 6001,
  organizationSettingsTemplates = 6002,
  organizationSettingsPreferences = 6003,
  organizationSettingsBilling = 6004,
  organizationSettingsConnections = 6005,
  organizationSettingsProfiles = 6006,
  organizationSettingsPeerOrganizations = 6007,

  formAnalystDashboardListView = 7000,
  formAnalystDashboardSummaryView = 7001,
  submissionsAnalystDashboard = 7002,
  formsAnalystDashboard = 7003,
  objectModelsAnalystDashboard = 7004,

  analytics = 7100,

  editDashboard = 7200,
  previewDashboard = 7201,

  accountProfile = 8000,
  accountSecurity = 8001,
  accountThemes = 8003,

  manageDocuments = 9000,

  syncRun = 10001,
  syncReactivate = 10002,
  endPointTest = 10003,
  syncDeactivate = 10004,

  debugSpans = 11000,
  debugEvents = 11100,

  userType = 12000,
  editUserType = 12001,
  deleteUserType = 12002,
  userTypeObjectModels = 12003,
  publishUserType = 12004,
  unpublishUserType = 12005,

  applications = 13000,
  applicationOverview = 13001,
  applicationGroupsAndPermissions = 13002,
  applicationGroupDocPermissions = 13003,
  applicationExportAppUserPermissions = 13004,
  applicationExportAppPermissions = 13005,
  applicationTransferOwnership = 13006,

  systemDiagrams = 14000,
  newSystemDiagram = 14101,
  editSystemDiagram = 14102,

  formSubmission = 15001,
  editFormSubmission = 15002,
  verifyActionFormSubmission = 15003,
  validateObjectModelsFormSubmission = 15004,
  originalFormSubmission = 15005,

  formSubmissionStep = 16001,
  formSubmissionStepDropzoneAction = 16002,
  formSubmissionStepSubmit = 16003,
  formSubmissionStepFileUploads = 16004,
  formSubmissionStepFileUpload = 16005,
  formSubmissionSearchObjectModelEntriesForLookupField = 16006,
  formSubmissionStepPay = 16007,
  formSubmissionStepViewInvoice = 16008,
  formSubmissionStepCreateCopyForDataEditor = 16009,
  formSubmissionStepAssignCompleter = 16010,
  formSubmissionStepSearchForCompleters = 16011,
  reassignMultiStepFormSubmissionStep = 16012,
  formSubmissionStepMoveOn = 16013,

  discardRevisedFormSubmission = 17001,

  resetPreviewTemplate = 18001,

  dataTagAssignments = 19002,
  appDataTagAssignmentsSearchTaggable = 19003,

  appDataTagTaggables = 20001,
  appDataTagTaggableFields = 20002,
  appDataTagTaggableTaggedFieldInfo = 20003,
}

// try to keep these in same order as above?
const r = Route;
export const RouteUrlTemplate: {[key in Route]: string}  = {
  [r.root]: '/',

  [r.dashboard]: '/',
  [r.actionsDashboard]: '/dashboard/actions',
  [r.pendingActionsActionsDashboard]: '/dashboard/actions/pending_actions',
  [r.pendingAssignmentsActionsDashboard]: '/dashboard/actions/pending_assignments',
  [r.previouslyReviewedSubmissionsActionsDashboard]: '/dashboard/actions/previously_reviewed_submissions',
  [r.editSubmissionFromDashboard]: '/submissions/:id/edit',
  [r.submissionsDashboard]: '/dashboard/submissions',
  [r.organizationMemberships]: '/organization/members',
  [r.organizationGroups]: '/organization/groups',
  [r.organizationRoles]: '/organization/roles',
  [r.organizationGroupSearchUsers]: '/organizations/:org_id/groups/:group_id/search_users',
  [r.recentlyUsedDocuments]: '/organizations/:id/recently_used_documents',
  [r.organizationSearchGroups]: '/organizations/:id/search_groups',
  [r.notifications]: '/notifications',
  [r.organizationQuickLinkFolders]: '/organization/quick_link_folders',
  [r.organizationSearchPaymentGateways]: '/organizations/:id/payment_gateways/search',
  [r.organizationPaymentGateway]: '/organizations/:organization_id/payment_gateways/:id',

  // legacy organizations controller routes
  [r.organizationSearchForms]: '/organizations/:id/search_forms',

  [r.editForm]: '/forms/:id/edit',
  [r.formSubmissionCreate]: "/forms/:id/create_submission",
  [r.formSubmissionCreateOnFirstAutosave]: "/forms/:id/create_submission_on_first_autosave",
  [r.resetPreviewForm]: "/forms/:id/reset_preview",
  [r.formSubmissionCreatePreview]: "/forms/:id/create_preview",
  [r.formSearchObjectModelEntriesForLookupField]: "/forms/:id/search_object_model_entries_for_lookup_field",
  [r.formSubmissionNew]: "/forms/:id/submission",

  [r.editLicense]: '/licenses/:id/edit',
  [r.searchAwardedLicenses]: '/licenses/search_awarded_licenses',

  [r.editCertificate]: '/certificates/:id/edit',
  [r.fetchSourceDocument]: '/certificates/:id',
  [r.fetchCertificate]: 'certificates/fetch_certificate',
  [r.certificatePreview]: '/certificates/:id/preview',
  [r.editObjectModel]: '/object_models/:id/edit',
  [r.editObjectModelRelationships]: '/object_models/:id/edit/relationships',
  [r.searchObjectModels]: '/object_models/search',
  [r.objectModels]: '/object_models/fetch',
  [r.objectModelProperties]: '/object_models/:id/properties',
  [r.objectModelLinkedForms]: '/object_models/:id/search_linked_forms',
  [r.objectModelEntries]: 'object_models/:object_model_id/entries',
  [r.objectModelFakeEntries]: 'object_models/:object_model_id/fake_entries',
  [r.publishObjectModel]: 'object_models/:id/publish',
  [r.objectModelPublishingDependencies]: 'object_models/:id/publishing_dependencies',
  [r.objectModelPublishedObjectModel]: 'object_models/:id/published',
  [r.objectModelEntriesNew]: '/object_models/:object_model_id/entries/new',
  [r.objectModelEntriesEdit]: '/object_models/:object_model_id/entries/:entry_id/edit',
  [r.fetchEntryRelationsAndEntries]: '/entries/:id/fetch_entry_relations_and_entries',
  [r.checkForEntryRelation]: '/published_object_model_relations/:id/check_for_entry_relation',
  [r.objectModelEntriesPerformAction]: '/object_models/:object_model_id/entries/:entry_id/perform_action',
  [r.objectModelEntriesChangeHolder]: '/object_models/:object_model_id/entries/:entry_id/change_holder',
  [r.objectModelEntriesResendClaimRecordNotification]: '/object_models/:object_model_id/entries/:entry_id/resend_claim_record_notification',
  [r.objectModelEntriesResendAccountRelationClaimRecordNotification]: '/object_models/:object_model_id/entries/:entry_id/resend_account_relation_claim_record_notification',
  [r.objectModelEntriesCreateShell]: '/object_models/:object_model_id/entries/create_shell',
  [r.objectModelEntriesInspect]: '/object_models/:object_model_id/entries/:entry_id/scheduled_triggers',
  [r.objectModelSearchProcessFlows]: '/object_models/:id/search_process_flows',
  [r.objectModelSearchDetailViews]: '/object_models/:id/search_detail_views',
  [r.objectModelPerformAction]: '/object_models/:id/perform_action',
  [r.publishedAccountRelationSearchUsers]: '/published_object_model_relations/:id/search_users_for_filter',

  [r.objectModelListViews]: '/object_models/:object_model_id/list_views',
  [r.objectModelRelatedListViews]: '/object_models/:id/related_list_views',
  [r.objectModelShow]: 'object_models/:id',

  [r.listViews]: '/list_views/',
  [r.editListView]: '/list_views/:id/edit',
  [r.editListViewLayout]: '/list_views/:id/edit/layout',
  [r.editListViewFilters]: '/list_views/:id/edit/filters',
  [r.editListViewSettings]: '/list_views/:id/edit/settings',
  [r.previewListView]: '/list_views/:id/preview',
  [r.entriesListView]: '/list_views/:id/entries',
  [r.fakeEntriesListView]: '/list_views/:id/fake_entries',
  [r.listView]: '/list_views/:id',
  [r.entityDashboardListView]: '/dashboard/list_views/:id',
  [r.publishListView]:  '/list_views/:id/publish',
  [r.listViewClone]: '/list_views/:id/clone',
  [r.listViewPublishingDependencies]: 'list_views/:id/publishing_dependencies',
  [r.listViewBulkActions]: '/list_views/:list_view_id/bulk_actions',
  [r.listViewForLookup]: '/list_views/list_view_for_lookup',

  [r.editObjectModelActions]: '/object_models/:id/edit/actions',
  [r.objectModel]: '/object_models/:id/properties',
  [r.detailViews]: '/detail_views/',
  [r.editDetailView]: '/detail_views/:id/edit',
  [r.publishDetailView]:  '/detail_views/:id/publish',
  [r.detailViewPublishingDependencies]: 'detail_views/:id/publishing_dependencies',
  [r.associatedListViewDetailView]: '/detail_views/:detail_view_id/associated_list_views/:list_view_id',
  [r.detailView]: '/detail_views/:id/entry/:entry_id',
  [r.previewDetailView]: '/detail_views/:id/preview',
  [r.userDashboardDetailView]: '/dashboard/detail_views/:id/entry/:entry_id',
  [r.detailViewClone]: '/detail_views/:id/clone',
  [r.previewDetailViewListView]: '/detail_views/:detail_view_id/preview/list_views/:list_view_id',
  [r.detailViewFormSubmissionList]: '/detail_views/:id/form_submissions',
  [r.detailViewContentElementLinkedForms]: '/detail_views/:id/content_element_linked_forms',
  [r.detailViewContentElementLinkedFormSubmissions]: '/detail_views/:id/content_element_linked_form_submissions',
  [r.detailViewFileAttachments]: '/detail_views/:detail_view_id/entry/:entry_id/property/:property_id/attachments',
  [r.modelHistoryView]: '/detail_views/:detail_view_id/entry/:entry_id/history/:history_id',
  [r.detailViewEditMode]: '/detail_views/:detail_view_id/entry/:entry_id/edit',
  [r.detailViewEntryShow]: 'detail_views/:detail_view_id/entry/:entry_id',

  [r.mapping]: '/mappings',
  [r.editMapping]: '/mappings/:id/edit',
  [r.mappingPublishedMapping]: '/mappings/:id/published',
  [r.mappingPublishingDependencies]: 'mappings/:id/publishing_dependencies',
  [r.publishMapping]: 'mappings/:id/publish',
  [r.mappingLinkedModelData]: '/mappings/:id/linked_model_data/:linked_model_id',

  [r.publishPublicProfile]: "/public_profiles/publish",
  [r.unpublishPublicProfile]: "/public_profiles/unpublish",
  [r.editPublicProfile]: "/public_profiles/:id/edit",
  [r.publicProfile]: "/public_profiles",
  [r.getApplication]: "/public_profiles/:id/get_application",

  [r.entityType]: '/entity_types',
  [r.editEntityType]: '/entity_types/:id/edit',
  [r.publishEntityType]: "/entity_types/publish",
  [r.unpublishEntityType]: "/entity_types/unpublish",
  [r.deleteEntityType]: "entity_types/:id",
  [r.entityTypeObjectModels]: "entity_types/:id/object_models",

  [r.userType]: '/user_types',
  [r.editUserType]: '/user_types/:id/edit',
  [r.deleteUserType]: "user_types/:id",
  [r.userTypeObjectModels]: "user_types/:id/object_models",
  [r.publishUserType]: "user_types/publish",
  [r.unpublishUserType]: "user_types/unpublish",

  [r.objectModelRelations]: 'object_models/:id/relations',

  [r.analytics]: '/analytics',

  [r.editVisualization]: '/visualizations/:id/edit',
  [r.previewVisualization]: 'visualizations/:id/preview',
  [r.publishVisualization]: '/visualizations/:id/publish',
  [r.visualizationShow]: '/visualizations/:id/',
  [r.processFlows]: '/process_flows',
  [r.editProcessFlow]: '/process_flows/:id/edit',
  [r.processFlowSearchObjectModels]: '/process_flows/search_object_models',
  [r.processFlowSearchForms]: '/process_flows/search_forms',
  [r.processSearchCertificates]: '/process_flows/search_certificates',
  [r.processFlowSearchProcessFlows]: '/process_flows/search_process_flows',
  [r.executeDebugProcessFlow]: '/process_flows/:id/execute_debug',
  [r.processFlowSearchDetailViews]: '/process_flows/search_detail_views',
  [r.processFlowSearchListViews]: '/process_flows/search_list_views',

  [r.resumeProcessFlowSubmission]: '/process_flow_submissions/:id/resume',
  [r.processFlowSubmissionPaused]: '/process_flow_submissions/:id/paused',
  [r.processFlowSubmissionFileUploads]: '/process_flow_submissions/:process_flow_submission_id/file_uploads',
  [r.processFlowSubmissionFileUpload]: '/process_flow_submissions/:process_flow_submission_id/file_uploads/:id',

  [r.fetchCertificateDynamicInputs]: '/process_flows/get_certificate_dynamic_inputs',
  [r.getObjectModelRelations]: '/process_flows/get_object_model_relations',
  [r.publishProcessFlow]: 'process_flows/:id/publish',
  [r.processFlowPublishingDependencies]: 'process_flows/:id/publishing_dependencies',

  [r.editDashboard]: '/dashboard/:id/edit',
  [r.previewDashboard]: '/dashboard/:id/edit/preview',

  [r.portals]: '/portals',
  [r.editPortal]: '/portals/:id/edit',

  [r.organizationSettingsInfo]: '/organization/settings/info',
  [r.organizationSettingsBranding]: '/organization/settings/branding',
  [r.organizationSettingsTemplates]: '/organization/settings/templates',
  [r.organizationSettingsPreferences]: '/organization/settings/preferences',
  [r.organizationSettingsBilling]: '/organization/settings/billing',
  [r.organizationSettingsConnections]: '/organization/settings/connections',
  [r.organizationSettingsProfiles]: '/organization/settings/profiles',
  [r.organizationSettingsPeerOrganizations]: '/organization/settings/peer_organizations',

  [r.formAnalystDashboardListView]: '/analyst_dashboard/forms/:id/list',
  [r.formAnalystDashboardSummaryView]: '/analyst_dashboard/forms/:id/summary',
  [r.submissionsAnalystDashboard]: '/analyst_dashboard/submissions',
  [r.formsAnalystDashboard]: '/analyst_dashboard/forms',
  [r.objectModelsAnalystDashboard]: '/analyst_dashboard/object_models/:id',

  [r.accountProfile]: '/account/profile',
  [r.accountSecurity]: '/account/security',
  [r.accountThemes]: '/account/themes',

  [r.manageDocuments]: '/documents',

  [r.publishPublicProfile]: "/public_profiles/publish",
  [r.unpublishPublicProfile]: "/public_profiles/unpublish",
  [r.editPublicProfile]: "/public_profiles/:id/edit",
  [r.publicProfile]: "/public_profiles/:id",
  [r.publicProfiles]: "/public_profiles",

  [r.syncRun]: "organization/settings/connections/:connection_id/syncs/:id/run",
  [r.syncReactivate]: "organization/settings/connections/:connection_id/syncs/:id/reactivate",
  [r.syncDeactivate]: "organization/settings/connections/:connection_id/syncs/:id/deactivate",

  [r.endPointTest]: "organization/settings/connections/:connection_id/end_points/:id/test",

  [r.debugSpans]: "/debug/spans",
  [r.debugEvents]: "/debug/events",

  [r.applications]: "/apps",
  [r.applicationOverview]: "/apps/:id/overview",
  [r.applicationGroupsAndPermissions]: "/apps/:id/groups_and_permissions",
  [r.applicationGroupDocPermissions]: "/apps/:id/group_doc_permissions",

  [r.applicationExportAppUserPermissions]: "/apps/:id/users/:user_identifier/export_permissions",
  [r.applicationExportAppPermissions]: "/apps/:id/export_permissions",
  [r.applicationTransferOwnership]: "/apps/:id/transfer_ownership",

  [r.systemDiagrams]: '/system_diagrams',
  [r.newSystemDiagram]: '/system_diagrams/new',
  [r.editSystemDiagram]: '/system_diagrams/:id/edit',

  [r.formSubmission] : "/submissions/:id",
  [r.editFormSubmission]: "/submissions/:id/edit",
  [r.verifyActionFormSubmission]: "/submissions/:id/verify",
  [r.validateObjectModelsFormSubmission]: "/submissions/:id/validate_object_model",
  [r.originalFormSubmission]: "/submissions/:id/original",

  [r.formSubmissionStep]: "/submissions/:submissionId/steps/:id",
  [r.formSubmissionStepDropzoneAction]: "/submissions/:submissionId/steps/:id/file_uploads",
  [r.formSubmissionStepSubmit]: "/submissions/:submissionId/steps/:id/submit",
  [r.formSubmissionSearchObjectModelEntriesForLookupField]: "/submissions/:submissionId/steps/:id/search_object_model_entries_for_lookup_field",
  [r.formSubmissionStepFileUploads]: "/submissions/:submissionId/steps/:stepId/file_uploads",
  [r.formSubmissionStepFileUpload]: "/submissions/:submissionId/steps/:stepId/file_uploads/:id",
  [r.formSubmissionStepPay]: "/submissions/:submissionId/steps/:id/pay",
  [r.formSubmissionStepViewInvoice]: "/submissions/:submissionId/steps/:id/invoice",
  [r.formSubmissionStepCreateCopyForDataEditor]: "/submissions/:submissionId/steps/:id/create_copy_for_data_editor",
  [r.formSubmissionStepAssignCompleter]: "/submissions/:submissionId/steps/:id/assign/:userId",
  [r.formSubmissionStepSearchForCompleters]: "/submissions/:submissionId/steps/:id/search_for_completers",
  [r.reassignMultiStepFormSubmissionStep]: "/submissions/:submissionId/steps/:id/reassign_multi_step",
  [r.formSubmissionStepMoveOn]: "/submissions/:submissionId/steps/:id/move_on",

  [r.discardRevisedFormSubmission]: "/revise/:id/discard",

  [r.resetPreviewTemplate]: "/templates/:id/reset_preview",

  [r.dataTagAssignments]: "/data_tag_assignments",
  [r.appDataTagAssignmentsSearchTaggable]: "/apps/:appId/data_tag_assignments/search_taggable",

  [r.appDataTagTaggables]: "/apps/:appId/data_taggables",
  [r.appDataTagTaggableFields]: "/apps/:appId/data_taggables/:id/fields",
  [r.appDataTagTaggableTaggedFieldInfo]: "/apps/:appId/data_taggables/:id/tagged_field_info"
};

/**
 * Not ideal - think of something better that will remove OneStop-specific code from Formability
 */
export const RouteUrlOneStopTemplate: {[key in Route]?: string}  = {
  [r.dashboard]: '/dashboard',
};
